import { antdNotification } from '@hellodarwin/core/lib/features/providers/antd-app-provider';
import { createAsyncThunk } from '@reduxjs/toolkit';
const showErrorNotificationTranslated = (error) => {
    antdNotification.error({
        message: error.error,
    });
};
export const SliceRequest = (name, func) => {
    return createAsyncThunk(`contentful/${name}`, async (payload, { rejectWithValue }) => {
        try {
            const res = await func(payload);
            if (res === null || res === void 0 ? void 0 : res.error) {
                showErrorNotificationTranslated(res);
                return rejectWithValue(res);
            }
            return res;
        }
        catch (err) {
            showErrorNotificationTranslated(err.response.data.error_code);
            return rejectWithValue(err.response.data);
        }
    });
};
